import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {deleteComboTask} = Actions;

const DeleteModal = ({index, task, trigger, isOpen, closeModal}) => {
  const selectedCombo = useSelector((state) => state.comboTasks.selectedCombo);
  const dispatch = useDispatch();

  function handleClose() {
    closeModal();
  }

  function handleConfirmClick() {
    dispatch(deleteComboTask(index, selectedCombo.code, task));
  }

  return (
    <Modal
      trigger={trigger}
      open={isOpen}
      onClose={handleClose}
      size='small'
    >
      <Modal.Content>
        <h3>¿Desea eliminar la tarea {task.description}?</h3>
      </Modal.Content>
      <Modal.Actions>
        <Button inverted secondary onClick={handleClose}>Cancelar</Button>
        <Button inverted primary onClick={handleConfirmClick}>Confirmar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteModal;
